import { TGetEnumOptionsResDto } from "@/api/services/global/enum/dtos/get-enum-options.dto";
import { QUERY_KEYS } from "@/constants/queryKeys";
import { valueOf } from "@/types/common";
import { globalApi } from "@/utils/api";
import { useQuery } from "@tanstack/react-query";

export type TEnumName = valueOf<
  [
    "EUserType",
    "EAdminRole",
    "ECompanyContractStatus",
    "EInformationType",
    "EUserActiveStatus",
    "EEmploymentStatus",
    "ERetirementStatus",
    "EDocumentType",
    "EDocumentKey",
    "EDocumentStepKey",
    "EDocumentStatus",
    "ESubmitStatus",
    "EQuarter",
    "EEmployeeResidencePeriod",
    "EEmployeeResidenceStatus",
    "EEmployeeContractMainOccupation",
    "ESupportImplementationStatus",
    "EProvince",
    "EGender",
    "EEmployeeTrainingStatus",
    "EEmployeeCareerCompletionProof",
    "EEmployeeCareerSkillCertificationOne",
    "EEmployeeCareerSkillExamOne",
    "EEmployeeCareerLocation",
    "EEmployeeCareerJapaneseCertification",
    "EEmployeeCareerJapaneseExam",
    "EConvertStatus",
    "EConvertError",
    "EContactType",
    "ECompanySpecificIndustry",
    "EMaintenanceMode",
    "EConvertDocumentName",
    "EEmploymentContractModificationType",
    "EModifyContractTerminateReason",
    "EModifyContractTerminateReasonForEmployee",
    "EModifyContractTerminateReasonForCompany",
    "EModifyContractModificationReason",
    "EModifyContractChangeDispatchLocationReasons",
    "ESupportRegistered",
    "ESupportRecipient",
    "ETerminateContractMajorCategoryReason",
    "ETerminateContractSubcategoryReason",
    "ESupportContractSubcategoryReason",
    "ESupportSpecifiedSkill",
    "ESupportOutsourcingContractModificationType",
    "ERetirementReasonType",
    "EModifyContractTerminateReasonForEmployee",
    "ECurrentSituation",
    "EPlanToContinueActivity",
    "EMeasure",
    "ESpecificCircumstance",
    "ESpecificCircumstanceContent",
    "EAnyConsultation",
    "EAnyConsultationContent",
    "EPlanToChangeJob",
    "EPlanToChangeJobContent",
    "ESupportType",
    "ESupportContent",
    "EReasonReturnHome",
    "EReasonReturnHomeContent",
    "EPlanDateReturn",
    "EPlanDateReturnContent",
    "EPlanToMove",
    "EPlanToMoveContent",
    "EProvidedLegalProtection",
  ]
>;

export const fetchEnumApi = async (enumName: TEnumName): Promise<TGetEnumOptionsResDto> => {
  const rs = await globalApi.get<TGetEnumOptionsResDto>(`/enums/${enumName}/options`);
  return rs.data;
};

export const useEnum = (enumName?: TEnumName) => {
  const { data, ...rest } = useQuery({
    queryKey: [QUERY_KEYS.GLOBAL.FETCH_ENUM, enumName],
    queryFn: () => (enumName ? fetchEnumApi(enumName) : undefined),
    enabled: Boolean(enumName),
  });

  return { data: data?.data ?? [], ...rest };
};
